export default __webpack_public_path__ + "static/media/Logo_Final_Trans.e2fd77a6.png";